module.exports = __webpack_public_path__ + "static/media/hiking.0545dfad.svg";